<script setup lang="ts">
import { Form, Head, Link } from "@inertiajs/vue3";

import AuthCardShell from "@/components/auth-card-shell.vue";
import { Button } from "@/components/ui/button/index";
import { identityPasswordResetPath, signInPath } from "@/routes";

defineOptions({ inheritAttrs: false });
</script>

<template>
  <Head title="Recuperar contraseña" />

  <AuthCardShell
    title="Recuperar contraseña"
    description="Ingresá tu email y te vamos a enviar un enlace de restablecimiento."
  >
    <Form
      :action="identityPasswordResetPath()"
      method="post"
      disable-while-processing
      class="inert:pointer-events-none inert:opacity-80"
      #default="{ errors, processing }"
    >
      <div class="space-y-4">
        <div class="space-y-1.5">
          <label for="reset-email" class="text-sm font-medium">Correo electrónico</label>
          <input
            id="reset-email"
            name="email"
            type="email"
            required
            autocomplete="email"
            inputmode="email"
            placeholder="correo@ejemplo.com"
            class="input-field"
          />
          <p v-if="errors.email" class="text-sm text-destructive">
            {{ errors.email }}
          </p>
        </div>

        <Button type="submit" :disabled="processing" class="h-11 w-full text-base sm:h-10 sm:text-sm">
          {{ processing ? "Enviando..." : "Enviar enlace de restablecimiento" }}
        </Button>
      </div>
    </Form>

    <p class="mt-6 text-center text-sm text-muted-foreground">
      Volver a
      <Link
        :href="signInPath()"
        class="font-medium text-foreground underline-offset-4 hover:underline"
      >iniciar sesión</Link>
    </p>
  </AuthCardShell>
</template>
